import React from 'react';
import { Helmet } from 'react-helmet-async';

const OrganizationSchema = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "@id": "https://www.atom-group.ch/#organization",
    "name": "ATOM Group SA",
    "alternateName": "ATOM Group",
    "url": "https://www.atom-group.ch",
    "logo": "https://www.atom-group.ch/logo512.png",
    "image": "https://www.atom-group.ch/logo512.png",
    "description": "Cabinet de conseil financier indépendant en Suisse romande. Expertise en assurances, prévoyance, fiscalité et planification retraite.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "CH",
      "addressRegion": "Suisse Romande"
    },
    "areaServed": [
      {
        "@type": "Place",
        "name": "Vaud"
      },
      {
        "@type": "Place",
        "name": "Genève"
      },
      {
        "@type": "Place",
        "name": "Neuchâtel"
      },
      {
        "@type": "Place",
        "name": "Fribourg"
      },
      {
        "@type": "Place",
        "name": "Valais"
      }
    ],
    "knowsAbout": [
      "Assurances",
      "Prévoyance",
      "3ème pilier",
      "LPP",
      "Fiscalité",
      "Planification retraite",
      "Hypothèques",
      "Investissements"
    ],
    "memberOf": {
      "@type": "Organization",
      "name": "Association des Courtiers en Assurances",
      "alternateName": "ACA",
      "url": "https://aca-courtiers.ch/"
    },
    "sameAs": [
      "https://www.linkedin.com/company/atom-group-sa"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;
